import React from 'react';
import { WebinarItem as WebinarInfo, WebinarLandingItem } from '@pages/Webinars/Webinars.types';
import { formatTime, formatDate } from '@helpers/dateHelpers';

interface WebinarsProps {
  i18n: {
    Months: WebinarLandingItem['Months'];
    LiveLabel: string;
    DurationLabel: string;
    RegisterNowButtontext: string;
    ViewOnDemandButtonText: string;
  };
  webinarData: WebinarInfo;
  dateFormat: WebinarLandingItem['DateFormat'];
  onWebinarLinkClick: (webinar: WebinarInfo) => void;
  index: number;
}

export const WebinarItem = ({
  i18n,
  webinarData,
  onWebinarLinkClick,
  index,
  dateFormat,
}: WebinarsProps) => {
  if (!webinarData) {
    return null;
  }

  const webinarIsUpcoming = webinarData.WebinarType === 0;

  return (
    <div className='webinars' id={index + 'webinar-blocks'} key={index}>
      <div className='webinarImage'>
        <div className='imageText'>{webinarData.WebinarStatus}</div>
        {webinarData.WebinarImage && (
          <div className='webinar-block-img'>
            <img
              loading='lazy'
              src={webinarData.WebinarImage}
              alt={webinarData?.WebinarImageAlt || 'alfa laval'}
              height='360'
              width='640'
            />
          </div>
        )}
      </div>
      <div className='webinar-content'>
        <h2>{webinarData.Heading}</h2>
        <div className='webinarDescription'>
          <p
            dangerouslySetInnerHTML={{
              __html: webinarData.Description?.replace(/(<p[^>]+?>|<p>|<\/p>)/gim, ''),
            }}
          ></p>
        </div>
        <div className='webinarDate'>
          {webinarIsUpcoming && (
            <>
              <i className='pr-8 icon-future'></i>
              {i18n.LiveLabel + ' '}
              {webinarData.Date &&
                formatDate(webinarData.Date, dateFormat, {
                  dateFormat: 'DD/MM/YYYY',
                }) + ' '}
              {webinarData.WebinarTimeFormat === '12'
                ? ` ${formatTime(webinarData.Time)}`
                : webinarData.Time}
            </>
          )}

          {!webinarIsUpcoming && (
            <>
              <i className='pr-8 icon-past'></i>
              {webinarData.Date &&
                formatDate(webinarData.Date, dateFormat, {
                  dateFormat: 'DD/MM/YYYY',
                })}
            </>
          )}

          {webinarData.Duration && (
            <div className='webDuration'>{`${i18n.DurationLabel} ${webinarData.Duration}`}</div>
          )}
        </div>
      </div>
      <a
        className=' webinarsButton webinar-btn-link'
        onClick={() => onWebinarLinkClick(webinarData)}
        href={webinarData.WebinarLink?.Href}
        target={webinarData.WebinarLink?.Target || '_blank'}
        rel='noreferrer'
      >
        {webinarData.WebinarType === 0 ? i18n.RegisterNowButtontext : i18n.ViewOnDemandButtonText}
      </a>
    </div>
  );
};
